import { LOGIN_PATH } from '@/constants/routes';
import { ErrorScreen } from '@/pages/ErrorScreen';
import { AuthExperienceLayout } from '@/features/auth/components/AuthExperienceLayout';
import { LogoutIframe } from '@/features/auth/components/LogoutIframe';
import { ForceLoginState } from '@/providers/ForceLoginState';
import { PublicApp } from '@/routes/PublicApp';
import { Navigate, RouteObject } from 'react-router';

export const publicRoutes: RouteObject[] = [
  {
    Component: PublicApp,
    children: [
      {
        path: '/auth/logout-iframe',
        Component: LogoutIframe,
      },
      {
        path: '/auth/confirmation',
        lazy: async () => ({
          Component: (await import('@/features/auth/routes/Confirmation'))
            .ConfirmationPage,
        }),
      },
      {
        path: '/auth/confirmation/error',
        lazy: async () => ({
          Component: (await import('@/features/auth/routes/ConfirmationError'))
            .ConfirmationErrorPage,
        }),
      },
      {
        path: '/articles/:code',
        lazy: async () => ({
          Component: (
            await import('@/features/article-detail/routes/ArticleDetail')
          ).ArticleDetail,
        }),
      },
      {
        element: <ForceLoginState type="guestOnly" />,
        children: [
          {
            path: '/',
            element: <Navigate to={LOGIN_PATH} />,
          },
          {
            Component: AuthExperienceLayout,
            children: [
              {
                path: '/auth/*',
                lazy: async () => ({
                  Component: (await import('@/features/auth/routes'))
                    .AuthRoutes,
                }),
              },
              {
                path: '/password-reset/*',
                lazy: async () => ({
                  Component: (await import('@/features/password-reset/routes'))
                    .PasswordResetRoutes,
                }),
              },
            ],
          },
          {
            path: '*',
            element: <ErrorScreen opts={{ statusCode: 404 }} />,
          },
        ],
      },
    ],
  },
];
